import $ from 'jquery';
const baseUrl = '//eventsapi.gm99.com/activity/execute?name=sgbycz2&action=';
const loginUrl = '//passport.gm99.com/ajax/get_user_json';
const logoutUrl = '//passport.gm99.com/login/logout2';
const basicUrl = `${baseUrl}getConfig`;
const activityOneUrl = `${baseUrl}pickCoupon`;
const getLotteryUrl = `${baseUrl}pickCharge`;
const chanceFlashUrl = `${baseUrl}refresh`;
const exchangeUrl = `${baseUrl}pickTimesCharge`;
const signUrl = `${baseUrl}signIn`;
const getSignRewardUrl = `${baseUrl}pickSignIn`;
const getZhanliUrl = `${baseUrl}calCE`;
const getZhanliAwardUrl = `${baseUrl}pickCalCE`;
const recordUrl = `${baseUrl}userReward`;
const serverUrl = `${baseUrl}listServer`;
const characterUrl = `${baseUrl}getMobileGameRole`;
const getRewardUrl = `${baseUrl}get_gift`;

const ajax = {
  request(param) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: param.method || 'get',
        url: param.url || '',
        data: param.data || '',
        dataType: param.type || 'jsonp',
        jsonp: 'callback',
        success: function (res) {
          resolve(res);
        },
        error: function (errMsg) {
          reject(errMsg);
        },
      });
    });
  },
};

const api = {
  getRecord() {
    const params = {
      url: recordUrl,
    };
    return ajax.request(params);
  },
  getZhanliReward({ serverId, roleId, serverName, roleName }) {
    const params = {
      url: getZhanliAwardUrl,
      data: {
        params: JSON.stringify({
          serverId, roleId, serverName, roleName
        }),
      },
    };
    return ajax.request(params);
  },
  getZhanli() {
    const params = {
      url: getZhanliUrl,
    };
    return ajax.request(params);
  },
  getSignReward({ serverId, roleId, serverName, roleName, id }) {
    const params = {
      url: getSignRewardUrl,
      data: {
        params: JSON.stringify({
          serverId, roleId, serverName, roleName, id
        }),
      },
    };
    return ajax.request(params);
  },
  exchange({ serverId, roleId, serverName, roleName, id }) {
    const params = {
      url: exchangeUrl,
      data: {
        params: JSON.stringify({
          serverId, roleId, serverName, roleName, id
        }),
      },
    };
    return ajax.request(params);
  },
  chanceFlash() {
    const params = {
      url: chanceFlashUrl,
    };
    return ajax.request(params);
  },
  getLottery({ serverId, roleId, serverName, roleName }) {
    const params = {
      url: getLotteryUrl,
      data: {
        params: JSON.stringify({
          serverId, roleId, serverName, roleName
        }),
      },
    };
    return ajax.request(params);
  },
  getActivityQuan() {
    const params = {
      url: activityOneUrl,
    };
    return ajax.request(params);
  },
  doSign() {
    const params = {
      url: signUrl,
    };
    return ajax.request(params);
  },
  checkLogin() {
    const params = {
      url: loginUrl,
    };
    return ajax.request(params);
  },
  logout() {
    const params = {
      url: logoutUrl,
    };
    return ajax.request(params);
  },

  getBasicInfo() {
    const params = {
      url: basicUrl,
    };
    return ajax.request(params);
  },
  getServer() {
    const params = {
      url: serverUrl,
    };
    return ajax.request(params);
  },

  getCharacter(server_id) {
    const params = {
      url: characterUrl,
      data: {
        params: JSON.stringify({
          server_id,
        }),
      },
    };
    return ajax.request(params);
  },

  getReward(requestParam) {
    const params = {
      url: getRewardUrl,
      data: {
        params: JSON.stringify({
          ...requestParam,
        }),
      },
    };
    return ajax.request(params);
  },
};
export default api;
